import { RootStore } from "@/stores/RootStore";
import { EventDispatcher, navigate } from "@/events/eventsDomain";
import { isAdminRoute } from "@/routes/routes";
import { isTargetInput } from "@/utils/keyboardEvents";
const CHORD_TIMEOUT_MS = 1500;

const ADMIN_SHORTCUTS: Record<string, string> = {
  o: "",
  s: "shareholders/dashboard",
  d: "projects",
  c: "schedule",
  a: "archive",
  m: "messaging",
};

export function initKeyboardShortcuts(
  rootStore: RootStore,
  dispatch: EventDispatcher,
  onShowHelp: () => void,
): void {
  let awaitingSecondKey = false;
  let chordTimer: ReturnType<typeof setTimeout> | null = null;

  const resetChord = () => {
    awaitingSecondKey = false;
    if (chordTimer !== null) {
      clearTimeout(chordTimer);
      chordTimer = null;
    }
  };

  document.addEventListener("keydown", (event: KeyboardEvent) => {
    if (isTargetInput(event)) return;
    if (event.metaKey || event.ctrlKey || event.altKey) return;

    const key = event.key.toLowerCase();

    if (awaitingSecondKey) {
      resetChord();

      const route = rootStore.route;
      if (isAdminRoute(route)) {
        const path = ADMIN_SHORTCUTS[key];
        if (path !== undefined) {
          event.preventDefault();
          const orgNo = route.params.orgNo;
          dispatch([navigate(path ? `/company/${orgNo}/${path}` : `/company/${orgNo}`)]);
        }
      }

      return;
    }

    if (key === "g") {
      event.preventDefault();
      awaitingSecondKey = true;
      chordTimer = setTimeout(resetChord, CHORD_TIMEOUT_MS);
      return;
    }

    if (event.key === "?") {
      event.preventDefault();
      if (rootStore.userStore.isAuthenticated) {
        onShowHelp();
      }
      return;
    }
  });
}
